import { createApp } from 'vue'
import Store from 'store'
import ProductCarousel from './ProductCarousel'

const fetchProductSpotData = (carousel) => {
    if (carousel.dataset.carouselType === "ProductSpot") {
        const hasProductSpotTypeData = carousel.dataset.productSpotData ? JSON.parse(carousel.dataset.productSpotData) : []
        return hasProductSpotTypeData && hasProductSpotTypeData.length ? hasProductSpotTypeData : []
    }
}

const scrapeLinkSpotCardType = (carousel) => {
    const data = []
    const linkSpots = carousel.querySelectorAll('.nlx-link-spot')
    if (!linkSpots.length) return []

    linkSpots.forEach((item, index) => {
        const imageLink = item.querySelector('.nlx-link-spot__image-container')
        const title = item.querySelector('.nlx-link-spot__card-title')
        const description = item.querySelector('.nlx-link-spot__card-text')
        const links = Array.from(item.querySelectorAll('.nlx-link-spot__link'))

        data[index] = {
            imageHref: imageLink ? imageLink.children[0].getAttribute('src') : "",
            title: title ? title.innerText : "",
            description: description ? description.innerText : "",
            links: links ? links.map(paragraph => {
                return {
                    linkValue: paragraph.firstElementChild.innerText,
                    linkHref: paragraph.getAttribute('href')
                }
            }) : []
        }
    })
    return data
}


const scrapeAboutUsSpotCardType = (carousel) => {
    const data = []
    const aboutUsSpots = carousel.querySelectorAll('.nlx-about-us-spot')

    if (!aboutUsSpots.length) return []

    aboutUsSpots.forEach((item, index) => {
        const link = item.querySelector('.nlx-about-us-spot__click-layer')
        const imageLink = item.querySelector('.nlx-about-us-spot__image-container')
        const title = item.querySelector('.nlx-about-us-spot__paragraph')

        data[index] = {
            href: link ? link.getAttribute('href') : "",
            imageHref: imageLink ? imageLink.children[0].getAttribute('src') : "",
            title: title ? title.innerText : "",
        }
    })

    return data
}


const el = '.nlx-component--product-carousel'
const DOM = document.querySelectorAll(el)

if (DOM) {

    DOM.forEach((carousel, index) => {

        const carouselData = (carouselType) => {
            const dictionary = {
                'AboutUsSpot': scrapeAboutUsSpotCardType(carousel),
                'LinkSpot': scrapeLinkSpotCardType(carousel),
                'ProductSpot': fetchProductSpotData(carousel)
            }
            return dictionary[carouselType]
        }

        const propData = carouselData(carousel.dataset.carouselType)

        if (!propData) return false

        const carouselPropConfig = {
            carouselType: carousel.dataset.carouselType,
            carouselTitle: carousel.dataset.carouselTitle,
            carouselViewAllLink: carousel.dataset.carouselViewAllLink,
            carouselViewAllLinkText: carousel.dataset.carouselViewAllLinkText,
            data: carouselData(carousel.dataset.carouselType),
            id: index
        }

        const component = createApp(ProductCarousel, {...carouselPropConfig }).use(Store)
        component.mount(carousel)
    })
}